import { translateLabel } from 'FRONTEND/utils/translateLabel';

export const getRepeatedId = (id, counter) => {
  const separatorPosition = id.indexOf('_');
  const prefix = id.slice(0, separatorPosition);
  const suffix = id.slice(separatorPosition);
  return `${prefix}${counter}${suffix}`;
};

export const getLabelFromChoiceValue = ({ fieldValue, fieldChoices, locale }) => {
  const matchingChoice = fieldChoices.find(choice => choice === fieldValue || choice?.value === fieldValue);
  if (!matchingChoice) {
    return fieldValue;
  }
  if (typeof matchingChoice === 'string') {
    return matchingChoice;
  }
  return translateLabel(matchingChoice.label, locale);
};
